/**
 * Обрабатывает ошибки валидации Formik и возвращает объект touched,
 * преобразуя ошибки типа "required" или строковые ошибки в булево true.
 *
 * @param {Object} errors - Объект с ошибками, возвращаемый validateForm()
 * @returns {Object} - Объект для передачи в setTouched
 */
export const handleFormValidationErrors = (errors) => {
	return JSON.parse(
		JSON.stringify(errors, (key, value) => {
			if (value?.key === 'required' || typeof value === 'string') {
				return true
			}
			return value
		})
	)
}

/**
 * Функция для обработки ошибок валидации в формах Formik.
 * Принимает функцию validateForm, возвращает функцию-обработчик для кнопок подтверждения формы.
 * Помечаем все поля с ошибками как touched, чтобы сразу показать пользователю ошибки валидации на форме.
 * Преобразуем все ошибки типа "required" или строковые ошибки в булево true — для корректной работы setTouched.
 * @param {Function} validateForm - Функция validateForm из контекста Formik
 * @param {Function} setTouched - Функция setTouched из контекста Formik
 * @returns {Function} - Обработчик для кнопки отправки формы
 */
export const handleFormValidation = (validateForm, setTouched) => {
	return () => {
		validateForm().then((errors) => {
			if (Object.keys(errors).length > 0) {
				// Создаем объект с пометками всех полей как "тронутые"
				const touchedFields = {}

				// Рекурсивно обрабатываем вложенные структуры ошибок
				const markAsTouched = (obj, prefix = '') => {
					Object.keys(obj).forEach((key) => {
						const fieldPath = prefix ? `${prefix}.${key}` : key

						if (typeof obj[key] === 'object' && obj[key] !== null) {
							// Если это массив или объект, рекурсивно обрабатываем
							markAsTouched(obj[key], fieldPath)
						} else {
							// Помечаем поле как тронутое
							touchedFields[fieldPath] = true
						}
					})
				}

				markAsTouched(errors)
				setTouched(touchedFields)
			}
		})
	}
}
